import React, { Component } from 'react';
import Modal from './Modal';
import check from "../../assets/check.svg";
import equis from "../../assets/eliminar.svg"
import ComponenteContrasenia from './ComponenteContrasenia';
import '../../css/FormAcuerdoGeneral.css';
import axios from 'axios';
import Cookies from 'js-cookie';
import Header from './Header.js'
import Footer from './Footer.js'
import anuncioico from "../../assets/AnuncioICO.svg";
import jwt from 'jwt-decode'
import { Spinner } from 'react-bootstrap';
import Acuerdo from './Acuerdo.js'
import Vistapdf from "../components/Vistapdf";
import cerrar from "../../assets/cerrarSesion.svg";
import MenuUsuario from './MenuUsuario';
import { ComponenteSpinner } from '../adminComponents/ComponenteSpinner';

export class FormAcuerdoGeneral extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error_login: false,
            enlaceAcuerdo: "",
            modalIsOpen: false,
            verBoton: true,
            datosUsuario: {
                token: "",
                id: "",
                identificacion: "0",
                alias_sugerido: "",
                telefono: "",
                unidad: "",
                rol: "",
                correoAlterno: "",
                nombres: "",
                apellidos: "",
                username: "",
                correo: "",
                usuarioEscogido: ""
            },
            idAcueFirmElec:"",
            contra: {
                contrasena: "",
                contrasenaCumple: false,
                repetirContraCumple: false,
            },
            navigateCas: true,
            modalError: {
                show: false,
                titulo: "",
                mensaje: "",
                imagen: ""
            },
            IsSign: false,
            token_entraID: sessionStorage.getItem("access_token"),

        };

        this.abrirModalInfo = this.abrirModalInfo.bind(this);
        this.cerrarModalInfo = this.cerrarModalInfo.bind(this);

        this.abrirModalError = this.abrirModalError.bind(this);
        this.cerrarModalError = this.cerrarModalError.bind(this);
        this.cerrarModalFirmaGeneralExitosa = this.cerrarModalFirmaGeneralExitosa.bind(this);
        
    }

    cerrarModalFirmaGeneralExitosa() {
        this.setState({ error_login: false });
    }

    componentWillMount = () => {
        let queryString = window.location.search;
        if (queryString != "" && queryString != null && queryString != undefined)
            localStorage.setItem('servicio', queryString);
    }

    abrirModalError() {
        this.setState({
            modalError: {
                ...this.state.modalError,
                show: true
            }
        });
    }

    cerrarModalError() {
        this.setState({
            modalError: {
                titulo: "",
                mensaje: "",
                imagen: "",
                show: false
            }
        });
    }

    abrirModalInfo() {
        this.setState({ modalIsOpen: true });
    }

    cerrarModalInfo() {
        this.setState({ modalIsOpen: false });
        this.activarNavigateLogin();
    }

    activarNavigateLogin() {
        window.location.href = "/Inicio";
    }


    getCedulaByUsername = async (e) => {
        var username = this.state.datosUsuario.username;
        if (username != "") {
            await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/getcedulauser/${username}`)
                .then(r => {
                    if (r.status == 200) {
                        this.setState({
                            datosUsuario: {
                                ...this.state.datosUsuario,
                                identificacion: r.data.persona.identificacion,
                            }
                        }, () => {
                            this.setState({ navigateCas: false });
                            if (this.state.datosUsuario.identificacion != 0) {
                                this.validarFirmaAcuerdo();
                            }
                        })
                    }
                })
                .catch(error => {
                })
        }
    }

    cerrarSesion = async () => {
        Cookies.remove("token");
        Cookies.remove("cas");
        Cookies.remove("DatosPersonalesGIA.CAS");
        window.location.href = '/logout';
    }


    validarFirmaAcuerdo = async (e) => {
        var id_temp = this.state.datosUsuario.identificacion;
        if (id_temp != "") {
            await axios.get(`${process.env.REACT_APP_API}api/Persona/enlacefirmaacgen/${id_temp}`)
                .then(r => {
                    if (r.status == 200) {
                        this.setState({
                            IsSign: true,
                            enlaceAcuerdo: r.data,
                        })
                    }
                })
                .catch(error => {
                })
        }
    }
    
    async componentDidMount() {
        this.validarCAS();
    }

    obtenerTokenCuentaNueva  = async () => {
        const username = this.state.datosUsuario.username;
        if (username !== "") {
            try {
                const r = await axios.get(`${process.env.REACT_APP_API}api/CuentaUsuario/tokennuevacuenta/${username}`, {
                    headers: {
                        Authorization: `Bearer ${this.state.token_entraID}`
                    }
                });
                if (r.status === 200) {
                    sessionStorage.setItem("token_nueva_cuenta", r.data.token);
                }
            } catch (error) {
                console.error(error);
            }
        }
    };

    validarCAS() {
        try {
            var token = Cookies.get("token");
            this.state.datosUsuario.token = token;
            var tokendecode = jwt(token);
            var exp = tokendecode["exp"];
            
            this.setState(prev => ({
                datosUsuario: {
                    ...prev.datosUsuario,
                    token: token,
                    nombres: tokendecode["Nombres"],
                    apellidos: tokendecode["Apellidos"],
                    username: tokendecode["User"]
                }
            }),async ()=>{
                await this.obtenerTokenCuentaNueva();
                await this.getCedulaByUsername();
                //this.setState({ navigateCas: false});
            });
            return (null);
        } catch (error) {
            this.setState({ error_login: true })
        }
    };


    render() {
        var nombresCompletos = `${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`
        var username = `${this.state.datosUsuario.username}`
        if (this.state.navigateCas) {
            return (
                <div style={{ textAlign:'center', marginTop:'100px' }}>
                    <ComponenteSpinner></ComponenteSpinner>
                </div>
            );
        }
        return (
            <>
                <MenuUsuario
                    mostrarNombre={true}
                    nombresCompletos={`${this.state.datosUsuario.nombres} ${this.state.datosUsuario.apellidos}`}
                />
                <Header />

                {!this.error_login ? (
                    this.state.IsSign ? (
                        <div>
                            <div className="row">
                                <div className="col-md-9 col-lg-9 col-xs-9 col-sm-9"></div>

                                <div className="col-md-3 col-lg-3 col-xs-3 col-sm-3" id="cerrar_sesion">
                                    <div className="navBarInfo-texto-cerrar mt-3">
                                        <button
                                            className="navBarInfo-btn-iconos"
                                            onClick={this.cerrarSesion}
                                        >
                                            <img
                                                className="img-cerrar-acuerdo"
                                                src={cerrar}
                                                alt="Cerrar sesión"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <p className="acuerdogeneral-title mt-4">
                                ACUERDO DE USO DE DATOS PERSONALES Y MEDIOS ELECTRÓNICOS PARA EL ALMACENAMIENTO Y <br />
                                USO DE INFORMACIÓN REGISTRADA EN LOS SISTEMAS INFORMÁTICOS DE LA ESPOL.
                            </p>

                            <div className="acuerdogeneral-container">
                                <div className="container">
                                    <div className="row">
                                        <div></div>

                                        <div>
                                            <p className="acuerdogeneral-subtitulo" align="justify">
                                                <img src={anuncioico} className="acuerdogeneral-btn-logop" alt="" />
                                                PARA SU CONOCIMIENTO
                                            </p>

                                            <p className="acuerdogeneral-parraf" align="justify">
                                                <strong>
                                                    Estimado Sr.(a) {this.state.datosUsuario.apellidos},{" "}
                                                    {this.state.datosUsuario.nombres} usted ya ha firmado el
                                                    Acuerdo de uso de datos personales y medios electrónicos para el
                                                    almacenamiento y uso de información registrada en los sistemas
                                                    informáticos de la ESPOL.
                                                </strong>
                                            </p>

                                            <p className="acuerdogeneral-enlace" align="justify">
                                                En caso de querer dar de baja la aceptación del acuerdo, remita la
                                                solicitud al correo{" "}
                                                <a href="mailto:datospersonales@espol.edu.ec">
                                                    datospersonales@espol.edu.ec
                                                </a>.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="acuerdogeneral-pdfviewer">
                                <Vistapdf url={this.state.enlaceAcuerdo} />
                            </div>
                        </div>
                    ) : (
                        <Acuerdo
                            identificacion={this.state.datosUsuario.identificacion}
                            nombres={this.state.datosUsuario.nombres}
                            apellidos={this.state.datosUsuario.apellidos}
                            alias_sugerido={this.state.datosUsuario.alias_sugerido}
                            usuario_sugerido={this.state.datosUsuario.username}
                            correoAlterno={this.state.datosUsuario.correoAlterno}
                            rol={this.state.datosUsuario.rol}
                            telefono={this.state.datosUsuario.telefono}
                            unidad={this.state.datosUsuario.unidad}
                            tipoForm={"A"}
                            mensaje_titulo="Firma de acuerdo"
                            verbtngeneral={true}
                            firmadoGeneral={true}
                            idAcueFirmElec={this.state.idAcueFirmElec}
                        />
                    )
                ) : (
                    <Modal
                        isOpen={this.state.error_login}
                        cerrarModal={this.cerrarModalFirmaGeneralExitosa}
                        verBoton={true}
                        textoBoton="ACEPTAR"
                    >
                        <p className="text-center acuerdo-modalFME-titulo">
                            <strong>Error en el inicio de sesión</strong>
                        </p>

                        <div className="mb-3">
                            <img className="acuerdo-check" src={equis} alt="Error" />
                        </div>

                        <p className="text-center acuerdo-modalFME-texto">
                            <strong>
                                Error al validar los datos del usuario en el Servicio Activo.
                            </strong>
                        </p>
                    </Modal>
                )
                }
            </> 
        );
    }
}

export default FormAcuerdoGeneral
